import { render, staticRenderFns } from "./ConfirmationBand.vue?vue&type=template&id=44272ffe"
import script from "./ConfirmationBand.vue?vue&type=script&lang=js"
export * from "./ConfirmationBand.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationBand.vue?vue&type=style&index=0&id=44272ffe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports